<div>
  <app-forms-filter
    (search)="searchForms($event)">
  </app-forms-filter>
  <mat-divider></mat-divider>
  <app-forms-table *ngIf="forms"
    [forms]="forms.content"
    [pageSize]="forms.size"
    [totalElements]="forms.totalElements"
    (loadForms)="loadForms($event)">
  </app-forms-table>
</div>
